import {
  BlobSource,
  BufferTarget,
  Conversion,
  Input,
  MP4,
  Mp4OutputFormat,
  Output,
  WEBM,
  WebMOutputFormat,
} from 'mediabunny';

// Browsers write a recording as it happens, so the file has no length and no
// seek index: players can't scrub it, and Safari can't play some at all. This
// copies the audio and video into a new file that has both, without
// re-encoding. Anything it can't rebuild is returned as recorded.
export async function remuxRecording(recording: Blob): Promise<Blob> {
  try {
    const input = new Input({ source: new BlobSource(recording), formats: [MP4, WEBM] });
    const target = new BufferTarget();
    const output = new Output({
      format: recording.type.endsWith('/mp4')
        ? new Mp4OutputFormat({ fastStart: 'in-memory' })
        : new WebMOutputFormat(),
      target,
    });

    const conversion = await Conversion.init({
      input,
      output,
      copy: { mode: 'forced' },
      showWarnings: false,
    });
    if (!conversion.isValid || conversion.discardedTracks.length > 0) {
      return recording;
    }
    await conversion.execute();

    return target.buffer === null ? recording : new Blob([target.buffer], { type: recording.type });
  } catch {
    return recording;
  }
}
